import { useShallow } from "zustand/react/shallow";

import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import { CONTEXTS_COLUMN_ID } from "views/Account/Contexts/constants";
import { selectColumnsConfig } from "ds/components/Table/Settings/utils";
import { TableColumnsState } from "ds/components/Table/useTableStore/types";
import TableSettingsDrawerContent from "ds/components/Table/Settings/DrawerContent";

import useContextsTableStore from "../useContextsTableStore";
import useContextsListAnalytics from "../../useContextsListAnalytics";

const TableSettingsDrawer = createDrawer(() => {
  const { columnsConfig, columnsState, updateColumnsConfig, resetColumnsConfig } =
    useContextsTableStore(
      useShallow((state) => ({
        columnsConfig: selectColumnsConfig(state as TableColumnsState<string>),
        columnsState: state.columnsState,
        updateColumnsConfig: (visible: string[], hidden: string[]) =>
          state.setColumnsOrder?.(hidden as CONTEXTS_COLUMN_ID[], visible as CONTEXTS_COLUMN_ID[]),
        resetColumnsConfig: state.resetColumnsConfig,
      }))
    );

  const trackAnalytics = useContextsListAnalytics();

  return (
    <TableSettingsDrawerContent
      trackAnalytics={trackAnalytics}
      columnsConfig={columnsConfig}
      columnsState={columnsState}
      resetColumnsConfig={resetColumnsConfig}
      updateColumnsConfig={updateColumnsConfig}
    />
  );
});

export const showTableSettingsDrawer = createDrawerTrigger(TableSettingsDrawer);
